import { useQuery } from "@tanstack/vue-query";
import { getFormattedCurrencyAmount } from "mws-utils/lib";

import { queries } from "~/queries";

export default function () {
  const { isLoggedIn } = useAuth();
  const { data: bidder, isPending } = useQuery({
    ...queries.me.bidder(),
    enabled: isLoggedIn,
  });

  const { locale } = useI18n();
  const { activeCurrency } = useActiveCurrency();

  const bidLimitInActiveCurrency = computed(
    () =>
      bidder.value?.bidLimit.find(
        (p) => p.currency === activeCurrency.value.isoCurrencyCode,
      )?.price,
  );

  const formattedBidLimitAmount = computed(() => {
    const bidderBidLimit = bidder.value?.bidLimit;

    if (!bidderBidLimit) return undefined;

    if (bidLimitInActiveCurrency.value === undefined) return undefined;

    return getFormattedCurrencyAmount(
      locale.value,
      activeCurrency.value.isoCurrencyCode,
      bidLimitInActiveCurrency.value * 100, // bidLimit from the current user is in euros
    );
  });

  const bidVerified = computed(() => bidder.value?.bidVerified);
  const bidBlocked = computed(() => bidder.value?.bidBlocked);
  const partnersMarketingConsent = computed(
    () => bidder.value?.partnersMarketingConsent,
  );

  return {
    bidLimitInActiveCurrency,
    formattedBidLimitAmount,
    bidVerified,
    bidBlocked,
    partnersMarketingConsent,
    isPending,
  };
}
